import styled, { css } from 'styled-components';
import { Menu } from 'antd';
import { COLORS } from '@/theme';

const activeStyles = css`
  color: ${COLORS.BLACK_PRIMARY} !important;
  &::after {
    border-bottom-color: ${COLORS.BLACK_PRIMARY} !important;
  }
`;

const hoverStyles = css`
  &:hover {
    background-color: ${COLORS.YELLOW_PRIMARY} !important;
    &::after {
      border-bottom-color: ${COLORS.YELLOW_PRIMARY} !important;
    }
  }
`;

export const StyledMenu = styled(Menu)`
  &.ant-menu.ant-menu-light {
    background: inherit;
    border-inline-end: none !important;

    &.ant-menu-inline,
    &.ant-menu-vertical {
      .ant-menu-item,
      .ant-menu-submenu-title {
        ${hoverStyles};

        &:active {
          color: ${COLORS.BLACK_PRIMARY} !important;
          background-color: ${COLORS.YELLOW_PRIMARY} !important;
        }
      }

      .ant-menu-item-selected {
        background-color: ${COLORS.YELLOW_PRIMARY} !important;

        &:hover {
          background-color: ${COLORS.YELLOW_PRIMARY} !important;
        }
      }

      .ant-menu-submenu-selected > .ant-menu-submenu-title {
        color: ${COLORS.BLACK_PRIMARY} !important;
      }

      .ant-menu-sub.ant-menu-inline {
        background: transparent !important;
      }
    }

    &.ant-menu-horizontal {
      .ant-menu-item {
        ${hoverStyles};

        &-selected,
        &-active {
          ${activeStyles};
        }

        &:active {
          ${activeStyles};
          background-color: ${COLORS.YELLOW_PRIMARY} !important;
        }
      }
    }
  }
`;
